import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import lodash from 'lodash';

import { DndContext, closestCenter, PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';

import FetchModule from '../../Share/Network/FetchModule';
import LessonBox from './LessonBox';
import useDndAutoScroll from '../../Share/Normal/useDndAutoScroll';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import { ReactComponent as DefaultLogoSvg } from '../../../image/DefaultLogo.svg';
import { ReactComponent as PlusSvgIcon } from '../../../image/Plus.svg';
import LessonEditBox from './LessonEditBox';
import DeleteConfirmModal from './Modal/DeleteConfirmModal';
import CustomAlert from '../../Share/Normal/CustomAlert';
import NewLessonSaveModal from './Modal/NewLessonSaveModal';

export default function ClassView() {
  const history = useHistory();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [isClickedSaveLesson, setIsClickedSaveLesson] = useState(false);
  const [isConfirm, setIsConfirm] = useState(false);
  const [isViewCustomAlert, setIsViewCustomAlert] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [rendering, setRendering] = useState(false);
  const [memberShipData, setMemberShipData] = useState([]);
  const [useMemberShipData, setUseMemberShipData] = useState([]);
  const [memberShipBodyHeight, setMemberShipBodyHeight] = useState(0);
  const [lessonData, setLessonData] = useState([]);
  const [coachList, setCoachList] = useState([]);

  const [isProcessing, setIsProcessing] = useState(false);

  const [isClickedLessonEdit, setIsClickedLessonEdit] = useState(false);
  const [isClickedMemberShipEdit, setIsClickedMemberShipEdit] = useState(false);

  const [clickLessonData, setClickLessonData] = useState(undefined);
  const [clickEditLessonData, setClickEditLessonData] = useState(undefined);
  // const [clickEditMemberShipData, setClickEditMemberShipData] = useState(undefined);

  // 수업 순서 변경중 //
  const [isInProgress, setIsInProgress] = useState(false);
  // 수업 순서 변경중 //

  // 수업 추가하기 클릭시 이미 클릭했던 수업 정보 담기 //
  const [tempClickLessonData, setTempClickLessonData] = useState(undefined);

  const [toBeDeletedDivision, setToBeDeletedDivision] = useState('None');
  const [toBeDeletedData, setToBeDeletedData] = useState(undefined);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 250, tolerance: 5 } })
  );

  const { scrollContainerRef, onDragMove, stopAutoScroll } = useDndAutoScroll();
  const { scrollContainerRef: membershipScrollRef, onDragMove: onMembershipDragMove, stopAutoScroll: stopMembershipAutoScroll } = useDndAutoScroll();

  // Init API Call //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('lesson/zone', 'GET');

        if (responseData.status === 200) {
          setLessonData(responseData.data);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [rendering])

  // 코치 목록 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getData('coach/select/', 'GET');

        if (responseData.status === 200) setCoachList(responseData.data);
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // 수업 클릭시 회원권 내역 찾기 및 회원권 뷰 크기 계산 //
  useEffect(() => {
    if (clickLessonData === undefined) return;

    let finalData = [];

    for (let i = 0; i < memberShipData.length; i++) {
      if (memberShipData[i].lessonId === clickLessonData.id) {
        finalData.push(memberShipData[i]);
      }
    }

    setUseMemberShipData(finalData);

    if (finalData.length === 0) setMemberShipBodyHeight(97);
    else {
      let height = 97 + 21 + (30 * finalData.length);

      if (height > 472) setMemberShipBodyHeight(472);
      else setMemberShipBodyHeight(height);
    }
  }, [clickLessonData, memberShipData])


  // 수업 추가하기 클릭시 //
  function onClickAddLessonEdit() {
    setTempClickLessonData(clickLessonData);
    setClickLessonData(undefined);
    setClickEditLessonData(undefined);
    setIsClickedLessonEdit(true);
  }

  // 수업 추가하기 닫기 클릭시 //
  function onClickExitAddLessonEdit() {
    setClickLessonData(tempClickLessonData);
    setTempClickLessonData(undefined);
    setClickEditLessonData(undefined);
    setIsClickedLessonEdit(false);
  }

  // 수업 수정 클릭시 //
  function onClickEditLessonButton(data) {
    setClickEditLessonData(data);
    setTempClickLessonData(clickLessonData);
    setClickLessonData(undefined);
    setIsClickedLessonEdit(true);
  }

  // 회원권 추가하기 클릭시 //
  function onClickMemberShipEdit() {
    if (isClickedMemberShipEdit) return;

    // setClickEditMemberShipData(undefined);
    setIsClickedMemberShipEdit(true);
  }

  // 회원권 클릭시 ( 수정 겸용 ) //
  function onClickEditMemberShipButton(data) {
    // setClickEditMemberShipData(data);
    setIsClickedMemberShipEdit(true);
  }


  // 수업 저장 클릭시 //
  function onSaveLessonInfo(requestData) {
    if (requestData.id === undefined) {
      requestData.isAutoSaveAvailableReserveLesson = false;

      setClickLessonData(requestData);
      setIsClickedSaveLesson(true);
    }
    else {
      if (isProcessing) {
        alert(t('settingClasses.savingInProgress'));
        return;
      }

      setIsProcessing(true);

      requestData.isAutoSaveAvailableReserveLesson = false;
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('lesson/save', 'POST', requestData);

          if (responseData.status === 200) {
            // setMemberShipData(responseData.data.memberShips);
            // setLessonData(responseData.data.lessonInfos);
            let lesson = lessonData.slice();
            let isChanged = false;

            for (let i = 0; i < lesson.length; i++) {
              if (lesson[i].id === responseData.data.id) {
                lesson[i] = responseData.data;
                isChanged = true;
                break;
              }
            }

            if (!isChanged) lesson.push(responseData.data);

            setLessonData(lesson);
            onClickExitAddLessonEdit();
          }

          setIsProcessing(false);
        }
      )();
    }
  }

  // 수업 저장 클릭시 //
  function onClickSaveLessonInModal(isClicked) {
    if (isProcessing) {
      alert(t('settingClasses.savingInProgress'));
      return;
    }
    
    setIsProcessing(true);
    
    let requestData = lodash.cloneDeep(clickLessonData);
    
    requestData.isAutoSaveAvailableReserveLesson = isClicked;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('lesson/save', 'POST', requestData);

        if (responseData.status === 200) {
          let lesson = lessonData.slice();
          let isChanged = false;

          for (let i = 0; i < lesson.length; i++) {
            if (lesson[i].id === responseData.data.id) {
              lesson[i] = responseData.data;
              isChanged = true;
              break;
            }
          }

          if (!isChanged) lesson.push(responseData.data);

          setLessonData(lesson);
          onClickExitAddLessonEdit();
        }

        setIsProcessing(false);
        setIsClickedSaveLesson(false);
      }
    )();
  }

  // 회원권 삭제 클릭시 //
  function onClickDeletedMemberShip(data) {
    setIsConfirm(true);
    setToBeDeletedDivision('MemberShip');
    setToBeDeletedData(data);
  }

  // 수업 삭제 클릭시 //
  function onClickDeletedLesson(data) {
    setIsConfirm(true);
    setToBeDeletedDivision("Lesson");
    setToBeDeletedData(data);
  }

  // 삭제 취소 클릭시
  function deleteExitButtonClick() {
    setToBeDeletedDivision('None');
    setToBeDeletedData(undefined);
    setIsConfirm(false);
  }

  // 삭제 확인 버튼 클릭시
  function deleteYesClick() {
    if (toBeDeletedDivision === 'Lesson') {
      let requestData = {
        lessonId: toBeDeletedData.id
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('lesson/delete/', 'POST', requestData);
          
          if (responseData.status === 200) {
            onClickExitAddLessonEdit();
            setRendering(!rendering);
          }
          else if (responseData.status === 201) {
            setAlertText(t('settingClasses.errorMembershipConnected'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 203) {
            setAlertText(t('settingClasses.errorScheduleExists'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    else if (toBeDeletedDivision === 'MemberShip') {
      let requestData = {
        memberShipId: toBeDeletedData.id
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('membership/delete/', 'POST', requestData);

          if (responseData.status === 200) setRendering(!rendering);
          else if (responseData.status === 203) {
            setAlertText(t('settingClasses.errorUnexpiredMembership'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 204) {
            setAlertText(t('settingClasses.errorDeleteFailed'));
            setIsViewCustomAlert(true);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
    setIsConfirm(false);
  }

  // 드래그 앤 드롭 순서 변경 //
  function onDragEnd(event) {
    stopAutoScroll();
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = lessonData.findIndex(d => d.id === active.id);
    const newIndex = lessonData.findIndex(d => d.id === over.id);

    setLessonData(arrayMove(lessonData, oldIndex, newIndex));

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('lesson/change/order/', 'POST', {
          lessonId: active.id,
          orderNum: newIndex + 1
        });

        if (responseData.status === 200) setRendering(prev => !prev);
      }
    )();
  }

  // 회원권 드래그 앤 드롭 순서 변경 //
  function onDragEndMembership(event) {
    stopMembershipAutoScroll();
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = useMemberShipData.findIndex(d => d.id === active.id);
    const newIndex = useMemberShipData.findIndex(d => d.id === over.id);

    setUseMemberShipData(arrayMove(useMemberShipData, oldIndex, newIndex));

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('membership/change/order/', 'POST', {
          membershipId: active.id,
          orderNum: newIndex + 1
        });

        if (responseData.status === 200) setRendering(prev => !prev);
      }
    )();
  }

  // 인덱스 변경 Up Down 버튼 클릭시 //
  function onClickChangeIndex(division, index) {
    if (isInProgress) return;

    setIsInProgress(true);

    let changeIndex = division === 'UP' ? lessonData[index].orderNum - 1 : lessonData[index].orderNum + 1;

    // if (changeIndex > 0 && changeIndex < lessonData.length) {
      let requestData = {
        lessonId: lessonData[index].id,
        orderNum: changeIndex
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('lesson/change/order/', 'POST', requestData);

          if (responseData.status === 200) {
            setRendering(!rendering);
            setIsInProgress(false);
          }
          else setIsInProgress(false);
        }
      )();
    // }
  }

  // NewLessonSaveModal 닫기 //
  function onClickExitNewLessonSaveModal() {
    setIsClickedSaveLesson(false);
    setClickLessonData(undefined);
  }

  return (
    <TopLevelWrapper>
      {/* {isClickedSaveLesson && <LessonSaveModal onClickExit={() => setIsClickedSaveLesson(false)} onClickSave={onClickSaveLessonInModal}/>} */}
      {
        isClickedSaveLesson &&
        <NewLessonSaveModal
          onClickExit={onClickExitNewLessonSaveModal}
          onClickNoAdd={() => onClickSaveLessonInModal(false)}
          onClickAutoAdd={() => onClickSaveLessonInModal(true)} />
      }
      {/* {<LessonSaveModal onClickExit={() => setIsClickedSaveLesson(false)} onClickSave={onClickSaveLessonInModal}/>} */}
      {isViewCustomAlert && <CustomAlert text={alertText} closeFn={() => setIsViewCustomAlert(false)} />}
      {isConfirm && <DeleteConfirmModal title={toBeDeletedDivision === 'Lesson' ? t('settingClasses.deleteLesson') : t('settingClasses.deleteMembership')} itemName={toBeDeletedData.name + (toBeDeletedDivision === 'Lesson' ? t('settingClasses.lessonSuffix') : t('settingClasses.membershipSuffix'))} clickNoFn={deleteExitButtonClick} clickYesFn={deleteYesClick} />}
      <InfoBoxWrapper>
        <LessonBoxTotalWrapper isClickedLessonEdit={isClickedLessonEdit}>
          {
            // !isClickedMemberShipEdit &&
            <LessonBoxInnerWrapper isClickedMemberShipEdit={isClickedMemberShipEdit}>
              <LessonBoxWrapper ref={scrollContainerRef}>
                <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd} onDragMove={onDragMove} autoScroll={false}>
                  <SortableContext items={lessonData.map(d => d.id)} strategy={verticalListSortingStrategy}>
                    {
                      lessonData.map((data, index) => (
                        <LessonBox
                          key={'LessonBox-' + data.id}
                          data={data}
                          coachList={coachList}
                          onClickEditLessonButton={onClickEditLessonButton}
                          onClickDeletedLesson={onClickDeletedLesson}
                          index={index}
                          onClickChangeIndex={onClickChangeIndex}
                        />
                      ))
                    }
                  </SortableContext>
                </DndContext>
              </LessonBoxWrapper>
              <AddLessonButton onClick={onClickAddLessonEdit}>
                <TextWrapper>
                  <StyledPlusIcon style={{ color: theme.text }} />
                  <Text fontFmaily='NotoSansKR-Medium' fontSize={14} cursor='pointer'>{t('settingClasses.addLesson')}</Text>
                </TextWrapper>
              </AddLessonButton>
            </LessonBoxInnerWrapper>
          }
          {/* <MemberShipEditBox
            lessonData={lessonData}
            clickLessonData={clickLessonData}
            clickEditMemberShipData={clickEditMemberShipData}
            isClickedMemberShipEdit={isClickedMemberShipEdit}
            onClickExitAddMemberShipEdit={onClickExitAddMemberShipEdit}
            onSaveMemberShip={onSaveMemberShip} /> */}
        </LessonBoxTotalWrapper>
        <MemberShipBoxTotalWrapper>
          {
            (clickLessonData === undefined || isClickedSaveLesson) &&
              <EmptyMemberShipBoxWrapper>
                <EmptyLogoView />
              </EmptyMemberShipBoxWrapper>
          }
          <LessonEditBox
            clickEditLessonData={clickEditLessonData}
            isClickedLessonEdit={isClickedLessonEdit}
            onClickExitAddLessonEdit={onClickExitAddLessonEdit}
            onSave={onSaveLessonInfo} />
        </MemberShipBoxTotalWrapper>
      </InfoBoxWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 1035px;

  gap: 30px;
  
  margin-top: 20px;
  margin-bottom: 96px;

  transition: all 0.3s ease-in-out;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const LessonBoxTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 512px;
  max-height: 585px;

  // opacity: ${props => props.isClickedLessonEdit ? '0.2' : '1'};

  transition: all 0.3s ease-in-out;
`;

const LessonBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-left: -10px;

  z-index: ${props => props.isClickedMemberShipEdit ? `-3` : `1`};
  // opacity: ${props => props.isClickedMemberShipEdit ? `0` : `1`};

  transition: all 0.3s ease-in-out;
`;

const LessonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-left: 10px;
  padding-bottom: 10px;

  box-sizing: border-box;
  width: 533px;
  max-height: 512px;

  gap: 10px;

  overflow-y: scroll;
  overflow-x: hidden;

	&::-webkit-scrollbar {
		width: 11px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
		border: 4.5px solid transparent;
		border-left-width: 5px;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const AddLessonButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;
  margin-left: 10px;

  width: 512px;
  height: 60px;

  color: ${props => props.theme.text};

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: 0px 10px 10px rgba(0, 54, 71, 0.02);

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const MemberShipBoxTotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 512px;
  min-width: 512px;
  max-width: 512px;

  overflow: hidden;
`;

const EmptyMemberShipBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 511.5px;
  min-width: 511.5px;
  max-width: 511.5px;
  height: 510px;
`;

const MemberShipBoxTitle = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 52px;

  border-radius: 12px 12px 0px 0px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;
`;

const MemberShipBoxBody = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: center;

  color: ${props => props.theme.text};

  width: 100%;
  height: ${props => props.height}px;

  overflow: hidden;

  transition: all 0.3s ease-in-out;

  border-radius: 0px 0px 30px 30px;
  background-color: ${props => props.theme.subBackground};
`;

const MemberShipScrollBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.isExist ? `31` : `0`}px;

  width: 459px;
  max-height: 344px;

  gap: 10px;

  overflow-y: scroll;
  overflow-x: hidden;

  transition: all 0.3s ease-in-out;

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

// const MemberShipInfoBox = styled.div`
//   display: flex;
//   flex-direction: row;

//   justify-content: flex-start;
//   align-items: flex-start;

//   min-width: 100%;
//   height: 20px;
// `;

const AddMemberShipButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  margin: 37px 0px 15px 0px;

  width: 442px;
  height: 45px;

  border-radius: 12px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const EmptyLogoView = styled(DefaultLogoSvg)`
  width: 130px;
  height: 130px;

  margin-top: 63px;
  margin-left: 20px;

  & path:nth-child(1) {
    fill: ${props => props.theme.logo1};
  }

  & path:nth-child(2) {
    fill: ${props => props.theme.logo2};
  }

  & path:nth-child(3) {
    fill: ${props => props.theme.logo1};
  }

  & path:nth-child(4) {
    fill: ${props => props.theme.logo3};
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;
`;

const StyledPlusIcon = styled(PlusSvgIcon)`
  width: 20px;
  height: 20px;

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;
